module.exports = __webpack_public_path__ + "media/icons/biznes-284bb278.png";